import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { HttpService } from "../../services/HttpService";

const initialState = {
  apiError: "",
};

export const updatePassword =
  (currentPassword: string, newPassword: string) => async (dispatch: any) => {
    try {
      const result = await HttpService.post(
        `${process.env.REACT_APP_API}/t4event/api/v02/user/change-password`,
        { currentPassword, newPassword }
      );

      if (result?.data) {
        return result?.data;
      }
    } catch (e: any) {
      dispatch(updateServerError(e.response?.data?.result || ""));
      return false;
    }
  };

const changePasswordReducer = createSlice({
  name: "changePassword",
  initialState,
  reducers: {
    updateServerError(state, action: PayloadAction<any>) {
      state.apiError = action.payload;
    },
  },
});

export const { updateServerError } = changePasswordReducer.actions;
export default changePasswordReducer.reducer;
